import { graphql } from "gatsby";
import { FileUploadDropZoneBasic, FileUploadDropZoneCustomValidation } from "../../../../src/examples/components/FileUploadDropZone";
import * as React from 'react';
export default {
  graphql,
  FileUploadDropZoneBasic,
  FileUploadDropZoneCustomValidation,
  React
};